import { render } from "./PlanTreso.vue?vue&type=template&id=7586d8a5"
import script from "./PlanTreso.vue?vue&type=script&lang=js"
export * from "./PlanTreso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__